import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { SkillType } from '@/types/schema';

import { getFormFields, getSectionLayout, validateForm } from '../../config/form';

function useScorecardFormProps({
  formTitle,
  skills,
}: {
  formTitle: string;
  skills?: Pick<SkillType, 'id' | 'name'>[];
}) {
  const { t } = useTranslation();
  const formFields = useMemo(() => getFormFields(t, { skills }), [skills, t]);
  const sectionLayout = useMemo(() => getSectionLayout(t), [t]);

  return {
    title: formTitle,
    description: t('Scorecard:Description'),
    fields: formFields,
    formName: 'ScorecardEditor',
    sectionLayout,
    validate: validateForm,
  };
}

export default useScorecardFormProps;
